import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-custom ml-4" }
const _hoisted_2 = { class: "accesscode-tab__content" }
const _hoisted_3 = { class: "p-field-label" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mt-4 d-flex align-items-center" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "mt-1 text-gray" }
const _hoisted_8 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_10 = { class: "p-field-label" }
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = { class: "mt-5" }
const _hoisted_15 = { class: "p-field-label" }
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = { class: "apartment__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_ToggleSwitchButton = _resolveComponent("ToggleSwitchButton")
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_KeypadCodeInput = _resolveComponent("KeypadCodeInput")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
          default: _withCtx(() => [
            _createVNode("div", null, [
              _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeSettingsLength")), 1),
              (!_ctx.adminView)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    class: "keypadlength__dropdown",
                    modelValue: _ctx.lengthValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.lengthValue = $event)),
                    options: _ctx.lengthOptions
                  }, null, 8, ["modelValue", "options"]))
                : (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.lengthValue), 1))
            ]),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_5, [
                _createVNode("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeSettingsPasspartout")) + " ", 1),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("small", null, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeSettingsPasspartoutSwitch")), 1)
                  ])
                ]),
                _createVNode(_component_ToggleSwitchButton, {
                  class: "ml-auto",
                  modelValue: _ctx.keypadCode.passpartoutEnabled,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.keypadCode.passpartoutEnabled = $event))
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.keypadCode.passpartoutEnabled)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_ListItemRadio, {
                      modelValue: _ctx.keypadCode.sameCode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.keypadCode.sameCode = $event)),
                      label: _ctx.$t('AppResourceEP.AccessCodeSameForBuildings'),
                      inputId: "SameCode",
                      name: "sameCode",
                      value: true
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_ListItemRadio, {
                      modelValue: _ctx.keypadCode.sameCode,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.keypadCode.sameCode = $event)),
                      label: _ctx.$t('AppResourceEP.AccessCodeDifferentForBuildings'),
                      inputId: "DifferentCode",
                      name: "differentCode",
                      value: false,
                      last: ""
                    }, null, 8, ["modelValue", "label"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.keypadCode.passpartoutEnabled && !_ctx.keypadCode.sameCode)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction")), 1),
                    _createVNode("div", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Lenght", [_ctx.keypadCode.requiredLength])) + " ", 1),
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Consecutive")) + " ", 1),
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_SameNumber")), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ElScrollbar, null, {
          default: _withCtx(() => [
            (_ctx.keypadCode.passpartoutEnabled && _ctx.keypadCode.sameCode)
              ? (_openBlock(), _createBlock("div", {
                  class: "building-code__input",
                  key: _ctx.forceUpdateKey,
                  onFocusCapture: _cache[6] || (_cache[6] = ($event: any) => (_ctx.drawAttention = false))
                }, [
                  _createVNode(_component_KeypadCodeInput, {
                    key: _ctx.forceUpdateKey,
                    modelValue: _ctx.keypadCode.passpartoutCode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.keypadCode.passpartoutCode = $event)),
                    label: _ctx.$t('AppResourceEP.KeypadCodePlaceHolder'),
                    alreadyUsedCodes: _ctx.getAlreadyUsedCodes(),
                    keypadCodeRequiredLength: _ctx.keypadCode.requiredLength,
                    drawAttention: _ctx.drawAttention,
                    onKeyCodeEdited: _ctx.handleKeyCodeEdited,
                    onErrorKeyCode: _ctx.handleErrorKeyCode
                  }, null, 8, ["modelValue", "label", "alreadyUsedCodes", "keypadCodeRequiredLength", "drawAttention", "onKeyCodeEdited", "onErrorKeyCode"]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction")), 1),
                    _createVNode("div", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Lenght", [_ctx.keypadCode.requiredLength])) + " ", 1),
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Consecutive")) + " ", 1),
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_SameNumber")), 1)
                    ])
                  ])
                ], 32))
              : _createCommentVNode("", true),
            (_ctx.keypadCode.passpartoutEnabled && !_ctx.keypadCode.sameCode)
              ? (_openBlock(), _createBlock("div", {
                  class: "building-code__input",
                  key: _ctx.forceUpdateKey,
                  onFocusCapture: _cache[7] || (_cache[7] = ($event: any) => (_ctx.drawAttention = false))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.savedBuildingsCode, (building, index) => {
                    return (_openBlock(), _createBlock(_component_KeypadCodeInput, {
                      key: building.buildingId,
                      modelValue: building.keypadCodePasspartoutCode,
                      "onUpdate:modelValue": ($event: any) => (building.keypadCodePasspartoutCode = $event),
                      label: building.buildingName,
                      alreadyUsedCodes: _ctx.getAlreadyUsedCodes(building.buildingId),
                      labelId: index,
                      keypadCodeRequiredLength: _ctx.keypadCode.requiredLength,
                      drawAttention: _ctx.drawAttention,
                      onKeyCodeEdited: _ctx.handleBuildingKeyCodeEdited,
                      onErrorKeyCode: _ctx.handleErrorKeyCode
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "alreadyUsedCodes", "labelId", "keypadCodeRequiredLength", "drawAttention", "onKeyCodeEdited", "onErrorKeyCode"]))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("footer", _hoisted_19, [
      _createVNode(_component_Button, {
        class: "p-button-rounded p-button-raised p-button--m",
        disabled: _ctx.saveDisabled,
        onClick: _ctx.handleSaveCode
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Save")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_component_DialogConfirmDelete, {
      isVisible: _ctx.showLengthWarning,
      title: _ctx.$t('AppResource.Warning'),
      message: _ctx.$t('AppResourceEP.KeyPadCodeConfirmationReset'),
      onHideDialog: _cache[8] || (_cache[8] = () => (_ctx.showLengthWarning = false)),
      onConfirm: _ctx.confirmChangeLength
    }, null, 8, ["isVisible", "title", "message", "onConfirm"])
  ], 64))
}